import Swiper from 'swiper';
import { Navigation, A11y, Keyboard } from 'swiper/modules';

export default function initFeaturedDestinations() {
  const sliders = document.querySelectorAll(
    '.aviatrix-block--featured-destinations .featured-destinations__slider'
  );

  sliders.forEach(root => {
    const swiperEl = root.querySelector('.featured-destinations__swiper');
    const prevEl   = root.querySelector('.featured-destinations__nav--prev');
    const nextEl   = root.querySelector('.featured-destinations__nav--next');
    if (!swiperEl) return;

    new Swiper(swiperEl, {
      modules: [Navigation, A11y, Keyboard],
      slidesPerView: 1.4,
      spaceBetween: 16,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      watchSlidesProgress: true,
      keyboard: { enabled: true, onlyInViewport: true },
      a11y: {
        prevSlideMessage: 'Previous destination',
        nextSlideMessage: 'Next destination',
        firstSlideMessage: 'This is the first destination',
        lastSlideMessage: 'This is the last destination',
      },
      navigation: {
        prevEl,
        nextEl,
        disabledClass: 'swiper-button-disabled',
      },
      breakpoints: {
        500: { slidesPerView: 2, spaceBetween: 16 },
        1024: {
          slidesPerView: 3,
          spaceBetween: 16,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        },
      },
    });
  });
}
